(() => {
  const bindingKey = "__ofkSoraPdpV2Bound";
  if (window[bindingKey]) return;
  window[bindingKey] = true;
  const returnFocus = new WeakMap();
  const findSection = (element) => element?.closest("[data-ofk-sora-section]");

  const closeLightbox = (section) => {
    const lightbox = section?.querySelector("[data-ofk-sora-lightbox]");
    if (lightbox?.open) lightbox.close();
  };

  const openLightbox = (openButton, event) => {
    const gallery = openButton.closest("[data-ofk-sora-gallery]");
    const section = findSection(openButton);
    const main = gallery?.querySelector("[data-ofk-sora-main]");
    const lightbox = section?.querySelector("[data-ofk-sora-lightbox]");
    const lightboxImage = section?.querySelector("[data-ofk-sora-lightbox-image]");
    if (!main || !(lightbox instanceof HTMLDialogElement) || !lightboxImage) return false;

    event.preventDefault();
    if (lightbox.open) return true;
    returnFocus.set(lightbox, openButton);
    lightboxImage.src = main.currentSrc || main.src;
    lightboxImage.alt = main.alt;
    lightbox.hidden = false;
    lightbox.showModal();
    document.documentElement.classList.add("ofk-sora-lightbox-open");
    lightbox.querySelector("[data-ofk-sora-lightbox-close]")?.focus({ preventScroll: true });
    return true;
  };

  // Native dialogs contain focus and handle Escape, including after section replacement.
  document.addEventListener("close", (event) => {
    const lightbox = event.target;
    if (!(lightbox instanceof HTMLDialogElement) || !lightbox.matches("[data-ofk-sora-lightbox]")) return;
    lightbox.hidden = true;
    document.documentElement.classList.remove("ofk-sora-lightbox-open");
    const trigger = returnFocus.get(lightbox);
    returnFocus.delete(lightbox);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }, true);

  // This image dialog has one control. Keep keyboard traversal on its close button.
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Tab") return;
    const lightbox = document.querySelector("[data-ofk-sora-lightbox][open]");
    if (!(lightbox instanceof HTMLDialogElement) || !lightbox.matches(":modal")) return;
    const closeButton = lightbox.querySelector("[data-ofk-sora-lightbox-close]");
    if (!closeButton) return;
    event.preventDefault();
    closeButton.focus({ preventScroll: true });
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll?.("[data-ofk-sora-lightbox][open]").forEach((lightbox) => lightbox.close());
  });

  const initMobileShopCta = () => {
    const mediaQuery = window.matchMedia("(max-width: 989px)");

    document.querySelectorAll("[data-ofk-sora-section]").forEach((section) => {
      const cta = section.querySelector("[data-ofk-sora-mobile-cta]");
      const buyPanel = section.querySelector("#sora-buy-panel");

      if (!cta || !buyPanel) return;

      const update = () => {
        const rect = buyPanel.getBoundingClientRect();
        const lightboxOpen = document.documentElement.classList.contains("ofk-sora-lightbox-open");
        const shouldShow = mediaQuery.matches && !lightboxOpen && rect.bottom < 0;

        section.querySelector("[data-sora-shopify-page]")?.classList.toggle("has-mobile-shop-cta", mediaQuery.matches);
        cta.classList.toggle("is-visible", shouldShow);
      };

      cta.addEventListener("click", (event) => {
        event.preventDefault();
        buyPanel.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
          block: "start",
        });
      });

      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);

      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", update);
      }

      update();
    });
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const thumb = target?.closest("[data-ofk-sora-thumb]");

      if (thumb) {
        const gallery = thumb.closest("[data-ofk-sora-gallery]");
        const main = gallery?.querySelector("[data-ofk-sora-main]");
        const thumbs = gallery?.querySelectorAll("[data-ofk-sora-thumb]");
        const source = thumb.dataset.src;

        if (!source || !main || !gallery || !thumbs) return;

        event.preventDefault();
        main.src = source;
        main.alt = thumb.dataset.alt || gallery.dataset.fallbackAlt || "SORA Japanese shikibuton";

        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });

        return;
      }

      const openButton = target?.closest("[data-ofk-sora-open]");

      if (openButton) {
        openLightbox(openButton, event);
        return;
      }

      const closeButton = target?.closest("[data-ofk-sora-lightbox-close]");

      if (closeButton) {
        event.preventDefault();
        closeLightbox(findSection(closeButton));
        return;
      }

      const lightbox = target?.closest("[data-ofk-sora-lightbox]");

      if (lightbox && target === lightbox) {
        closeLightbox(findSection(lightbox));
      }
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileShopCta, { once: true });
  } else {
    initMobileShopCta();
  }
})();
